// extracted by mini-css-extract-plugin
export default {"titleQuestion":"RegisterAuditorFormStepThree_titleQuestion__jBdjP","radio":"RegisterAuditorFormStepThree_radio__J4eKV"};